<template>
  <div class="grid-view" type="primary">
    <div class="main-content">
      <div class="section operations" style="height: 39px;">
        <div class="triggers" style="margin-top: 7px;">
          <div>
            <span style="display: inline-block;width: 90px;color: #333333;padding-left: 30px;vertical-align: middle;">{{ $t('CargoMsg.Cargo_AirlineCompany') }}</span>
            <el-input
              v-model="airPortMapping.airName"
              no="airName"
              style="width: 260px"
              size="mini"
              @change="airPortMapping.pageNum=1"
              @keyup.enter.native.prevent="fetchAirlineList"
            />
            <span style="display: inline-block;width: 100px;color: #333333;padding-left: 30px;vertical-align: middle;">IATA CODE</span>
            <el-input
              v-model="airPortMapping.iataCode"
              no="iataCode"
              style="width: 260px"
              size="mini"
              @change="airPortMapping.pageNum=1"
              @keyup.enter.native.prevent="fetchAirlineList"
            />
            <el-button no="toQuery" size="mini" type="primary" @click="fetchAirlineList">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
            <el-button
              no="query"
              size="mini"
              type="primary"
              @click="airlineAdd(true)"
            >{{ $t('CargoMsg.Cargo_NewTo') }}</el-button>
            <el-button
              no="editTo"
              size="mini"
              type="primary"
              @click="airlineAdd(false)"
            >{{ $t('CargoMsg.Cargo_EditTo') }}</el-button>
            <el-button
              no="delete"
              size="mini"
              type="danger"
              @click="toBatchDelAirline"
            >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper" style="min-height:350px">
        <cargo-ag-grid
          no="100002-grid"
          config-module="100002"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          v-show="airPortMapping.total>0"
          no="1000022-pagination"
          config-module="1000022"
          :total="airPortMapping.total"
          :page.sync="airPortMapping.pageNum"
          :limit.sync="airPortMapping.pageSize"
          @pagination="fetchAirlineList"
        />
      </div>
    </div>

    <el-dialog
      v-el-drag-dialog
      :visible.sync="airlineAddDialog.isShow"
      :title="airlineAddDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item required>
            <span slot="label">{{ $t('CargoMsg.Cargo_AirlineCompany') }}</span>
            <el-input v-model="airlineAddDialog.data.airName" style="width:100%;" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_MblCode') }}</span>
            <el-input v-model="airlineAddDialog.data.mblCode" style="width:100%;" />
          </el-form-item>
          <el-form-item required>
            <span slot="label">IATA CODE</span>
            <el-input v-model="airlineAddDialog.data.iataCode" style="width:100%;" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="airlineAddDialog.isAdd ? toAddAirline():editSeaPort()">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="airlineAddDialog.isShow=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  getAirlineList,
  updateAirline,
  addAirline,
  deleteAirline
} from '@/api/airport'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'AirlineCode',
  data() {
    return {
      fullscreenLoading: null,
      airlineAddDialog: {
        isShow: false,
        data: {},
        title: this.$t('CargoMsg.Cargo_NewTo'),
        isAdd: true
      },
      airPortMapping: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 10,
        airName: '', // 航空公司名称
        iataCode: '' // IATA CODE
      },
      gridOptions: {
        rowClassRules: {
          'grid-row-zebra-even': function(params) {
            return !(params.rowIndex % 2)
          },
          'grid-row-zebra-odd': function(params) {
            return (params.rowIndex % 2)
          }
        },
        rowSelection: 'multiple',
        suppressRowClickSelection: true
      },
      gridParams: {},
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AirlineCompany'),
          field: 'airName',
          width: 80
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblCode'),
          field: 'mblCode',
          width: 100
        }, {
          headerName: 'IATA CODE',
          field: 'iataCode',
          width: 100
        }
      ]
    }
  },
  mounted() {
    this.fetchAirlineList(true)
  },
  methods: {
    fetchAirlineList(forbidLoading = false) {
      if (!forbidLoading) {
        this.fullscreenLoading = getLoading()
      }
      Promise.all([getAirlineList({ ...this.airPortMapping })]).then(results => {
        const airline = results[0]
        this.airPortMapping.pageNum = airline.data.pageNum
        this.airPortMapping.pageSize = airline.data.pageSize
        this.airPortMapping.total = Number(airline.data.total)
        this.rowData = [...airline.data.list]
      }).finally(() => {
        if (!forbidLoading) {
          this.fullscreenLoading.close()
        }
      })
    },
    toBatchDelAirline() {
      if (!this.isSelect()) {
        return
      }
      const self = this

      this.$confirm(this.$t('Message.DeleteTheSelectedRecord'), this.$t('Message.Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const chooseRows = getGridSelected(this.gridOptions)
        deleteAirline(chooseRows).then(res => {
          if (res.ok) {
            this.$message.success(this.$t('Message.DeleteSucceeded'))
            self.fetchAirlineList()
          } else {
            this.$message({
              type: 'info',
              message: this.$t('Message.DeleteFail')
            })
          }
        })
      }).catch(() => {
        this.$message.info(this.$t('Message.DeletionCancelled'))
      })
    },
    // 新增列表弹窗
    airlineAdd(isAdd) {
      this.airlineAddDialog.isAdd = isAdd
      if (isAdd) {
        this.airlineAddDialog.data = {}
        this.airlineAddDialog.title = this.$t('CargoMsg.Cargo_NewTo')
        this.airlineAddDialog.isShow = true
      } else {
        if (!this.isSelect()) {
          return
        }
        this.airlineAddDialog.data = { ...getGridSelected(this.gridOptions)[0] }
        this.airlineAddDialog.title = this.$t('CargoMsg.Cargo_EditTo')
        this.airlineAddDialog.isShow = true
      }
    },
    // 不空校验
    toCheckSeaportForm() {
      const data = this.airlineAddDialog.data
      if (!data.airName) {
        this.$message.error(this.$t('CargoMsg.Cargo_AirlineCompany') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (!data.iataCode) {
        this.$message.error('IATA CODE' + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      return true
    },
    // 编辑
    editSeaPort() {
      if (!this.toCheckSeaportForm()) {
        return
      }
      return updateAirline(this.airlineAddDialog.data).then(res => {
        // IATA Code已存在
        if (res.data === -101) {
          this.$message.error(this.$t('Message.IATACodeRepeat'))
          // 航空公司名称已存在
        } else if (res.data === -102) {
          this.$message.error(this.$t('Message.AirCodeRepeat'))
        } else {
          this.airlineAddDialog.isShow = false
          this.$message({ message: this.$t('Message.AirlineInformationEditedSuccessfully'), type: 'success' })
          this.fetchAirlineList()
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },

    // 添加
    toAddAirline() {
      if (!this.toCheckSeaportForm()) {
        return
      }
      this.fullscreenLoading = getLoading()
      addAirline(this.airlineAddDialog.data).then(res => {
        // IATA Code已存在
        if (res.data === -101) {
          this.$message.error(this.$t('Message.IATACodeRepeat'))
          // 航空公司名称已存在
        } else if (res.data === -102) {
          this.$message.error(this.$t('Message.AirCodeRepeat'))
        } else {
          this.airlineAddDialog.isShow = false
          this.$message({ message: this.$t('Message.SuccessfullyAddedAirlineInformation'), type: 'success' })
        }
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    // 是否勾选
    isSelect() {
      const rows = getGridSelected(this.gridOptions)
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return false
      }
      if (rows.length > 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return false
      }
      return true
    }
  }

}
</script>

<style scoped lang="scss">
.add-basic-seaport ::v-deep {
  .ag-paging-page-summary-panel  {
    display: flex;
  }
}
</style>
